import React from "react";
import deLocale from "date-fns/locale/de";
import { differenceInHours, differenceInMinutes, format, formatDistance, parse } from "date-fns";
import { datePickerDisplayFormat, isoDateFormat } from "./formats";

const localeStringConfig = {
  currency: "EUR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
};

export const formatCurrency = value =>
  Number(value).toLocaleString("de-DE", {
    ...localeStringConfig,
    style: "currency"
  });

export const formatDecimalCurrency = value =>
  Number(value).toLocaleString("de-DE", {
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: "currency"
  });

export const formatWithThousandsSeparator = value =>
  Number(value).toLocaleString("de-DE", localeStringConfig);

export const formatPercent = value => `${value} %`;
export const formatPercentSafe = value =>
  value === null || value === undefined || value === "" ? "-" : `${value} %`;
export const formatArea = value => (
  <span>
    {formatWithThousandsSeparator(value)}
    {" m"}
    <sup>2</sup>
  </span>
);
export const formatDistanceInKm = value => `${formatWithThousandsSeparator(value)} km`;

export const formatYears = value => (value === 1 ? `${value} Jahr` : `${value} Jahre`);
export const formatMonths = value => (value === 1 ? `${value} Monat` : `${value} Monate`);
export const formatThousandsCurrency = value => `${formatWithThousandsSeparator(value)} T€`;

export function timeLabelSinceDate(date) {
  const now = new Date();
  const minutes = differenceInMinutes(now, date);

  if (minutes < 1) return "Gerade eben";

  if (minutes < 60) {
    return `${minutes} ${minutes !== 1 ? "Minuten" : "Minute"}`;
  }

  const hours = differenceInHours(now, date);
  if (hours < 24) {
    return `${hours} ${hours !== 1 ? "Stunden" : "Stunde"}`;
  }

  if (hours < 168) {
    const days = Math.floor(hours / 24);
    return `${days} ${days !== 1 ? "Tage" : "Tag"}`;
  }

  if (hours < 168 * 4) {
    const weeks = Math.floor(hours / 168);
    return `${weeks} ${weeks !== 1 ? "Wochen" : "Woche"}`;
  }

  const months = Math.floor(hours / 24 / 7 / 4);
  return `${months} ${months !== 1 ? "Monate" : "Monat"}`;
}

export const timeDistanceFromDate = pastDate =>
  formatDistance(pastDate, new Date(), { locale: deLocale });

export const timeDistanceFromISO = date =>
  formatDistance(parse(date, isoDateFormat, new Date()), new Date(), {
    locale: deLocale
  });
export const formatDateFromISO = date =>
  format(parse(date, isoDateFormat, new Date()), datePickerDisplayFormat);

export const getAgentsOptions = agents =>
  agents.map(agent => ({
    label: `${agent.firstName} ${agent.lastName}`,
    value: agent.id
  }));
